import React, { useState } from 'react';
import ModuleBadge from './ModuleBadge';
import BiQueryRow from './BiQueryRow';

export default function BiModuleSection({ category, queries }) {
  const [open, setOpen] = useState(true);

  // Group queries by subcategory within this category section
  const subMap = {};
  for (const q of queries) {
    const key = q.subcategory || '';
    if (!subMap[key]) subMap[key] = [];
    subMap[key].push(q);
  }
  const subGroups = Object.keys(subMap).sort().map(sub => ({ sub, items: subMap[sub] }));

  return (
    <div className="rounded-2xl overflow-hidden" style={{ backgroundColor: '#14161e', border: '1px solid #1e2130' }}>
      <button
        type="button"
        className="w-full flex items-center justify-between px-5 py-4"
        style={{ background: 'none', border: 'none', cursor: 'pointer', borderBottom: open ? '1px solid #1e2130' : 'none' }}
        onClick={() => setOpen(o => !o)}
      >
        <div className="flex items-center gap-3">
          <ModuleBadge module={category} />
          <span className="text-xs font-mono" style={{ color: '#374151' }}>
            {queries.length} {queries.length === 1 ? 'query' : 'queries'}
          </span>
        </div>
        <svg
          className="w-4 h-4 transition-transform duration-200"
          style={{ color: '#4b5563', transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }}
          fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="p-4 space-y-4">
          {subGroups.map(({ sub, items }) => (
            <div key={sub}>
              {sub && (
                <p className="text-xs font-semibold uppercase tracking-widest mb-2 px-1" style={{ color: '#4b5563' }}>
                  {sub}
                </p>
              )}
              <div className="space-y-2">
                {items.map(q => <BiQueryRow key={q.queryName} query={q} />)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
